export function bookingDisplayCode(id) {
  const clean = String(id || "").replace(/[^a-fA-F0-9]/g, "");
  let hash = 2166136261;
  for (let i = 0; i < clean.length; i += 1) {
    hash ^= clean.charCodeAt(i);
    hash = Math.imul(hash, 16777619) >>> 0;
  }
  const code = (hash % 9000000) + 1000000;
  return String(code).padStart(7, "0");
}
